import styled from 'styled-components';

const StyledFileInput = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

export default StyledFileInput;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledFileInput.js